import { useEffect, useRef, useState } from 'react';

/**
 * Hook para animaciones on scroll usando Intersection Observer
 * @param {Object} options - Opciones del Intersection Observer
 * @param {number} options.threshold - Porcentaje visible para activar (0-1)
 * @param {string} options.rootMargin - Margen del viewport
 * @param {boolean} options.triggerOnce - Si solo se anima una vez
 * @returns {[React.Ref, boolean]} - [ref para el elemento, isVisible]
 */
export function useScrollAnimation(options = {}) {
  const {
    threshold = 0.1,
    rootMargin = '0px',
    triggerOnce = true,
  } = options;

  const ref = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          if (triggerOnce) {
            observer.unobserve(element);
          }
        } else if (!triggerOnce) {
          setIsVisible(false);
        }
      },
      { threshold, rootMargin }
    );

    observer.observe(element);

    return () => {
      if (element) {
        observer.unobserve(element);
      }
    };
  }, [threshold, rootMargin, triggerOnce]);

  return [ref, isVisible];
}
